import Rapichontico from '../features/rapichontico/layouts/rapichontico';

export default function RapichonticoPage() {
    return <Rapichontico />;
}
